import { MethodEnum } from '@enum/method.enum';

export const axiosTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => `const axios = require('axios');

const headers = ${JSON.stringify(headers, null, '\t')};

const data = ${JSON.stringify(body, null, '\t')};

const config = {
  method: '${method}',
  maxBodyLength: Infinity,
  url: '${encodeURI(link)}',
  headers: headers,
  data: data
};

axios(config)
  .then((response) => {
    console.log(response.data);
  })
  .catch((error) => {
    console.log(error);
  });`;
